module.exports = __webpack_public_path__ + "media/images/default/pages/about/doctor-2-de37963ea51f0f0898dd2f158b9cf67c.jpg";